/* eslint-disable no-nested-ternary */
import { Autocomplete, CircularProgress, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { RECURRENCE_TYPES } from "lib/constants";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const generateOptionsFromNoOfDays = (days) => {
  const daysArr = [];
  for (let day = 1; day <= days; day += 1) {
    daysArr.push({
      value: day,
      label: day,
    });
  }
  return daysArr;
};

function Cadence({ formData, recurrenceTypes, recurrenceTypesLoading }) {
  const { values, errors, touched, setFieldValue } = formData;
  const {
    type: cadenceV,
    days: daysV,
    monthOfYear: monthOfYearV,
    dayOfMonth: dayOfMonthV,
    // dueDate: dueDateV,
    dueDateOption: dueDateOptionV,
    dueDateNum: dueDateNumV,
  } = values.cadence;
  const loginUser = useSelector((state) => state.loginUser.loginUserState);
  const [daysOptions, setDaysOptions] = useState([]);
  const [daysOfMonth, setDaysOfMonth] = useState([]);
  const dueDateOptions = generateOptionsFromNoOfDays(11);
  // const options = [
  //   {
  //     label: "No Recurrence",
  //     value: "no_recurrence",
  //   },
  //   {
  //     label: "Weekly",
  //     value: "weekly",
  //   },
  //   {
  //     label: "Monthly",
  //     value: "monthly",
  //   },
  //   {
  //     label: "Quarterly",
  //     value: "quarterly",
  //   },
  //   {
  //     label: "Annually",
  //     value: "annually",
  //   },
  // ];

  const handleDaysOptionChange = (filter) => {
    let optionsArr = [];

    if (filter === RECURRENCE_TYPES.WEEKLY) {
      for (let day = 1; day <= 7; day += 1) {
        optionsArr.push({
          value: day,
          label: moment.tz(undefined, loginUser.timezone).day(day).format("dddd"),
        });
      }
    }
    if (filter === RECURRENCE_TYPES.MONTHLY) {
      optionsArr = generateOptionsFromNoOfDays(31);
    }
    if (filter === RECURRENCE_TYPES.QUARTERLY) {
      optionsArr = generateOptionsFromNoOfDays(10);
    }
    if (filter === RECURRENCE_TYPES.ANNUALLY) {
      for (let day = 1; day <= 12; day += 1) {
        optionsArr.push({
          value: day,
          label: moment
            .tz(undefined, loginUser.timezone)
            .month(day - 1)
            .format("MMMM"),
        });
      }
    }

    setDaysOptions(optionsArr);
  };

  const handleMonthOfYearChange = (monthValue) => {
    const optionsArr = [];
    const days = moment
      .tz(undefined, loginUser.timezone)
      .month(monthValue - 1)
      .daysInMonth();
    for (let day = 1; day <= days; day += 1) {
      optionsArr.push({ value: day, label: day });
    }
    setDaysOfMonth(optionsArr);
  };

  useEffect(() => {
    if (cadenceV !== RECURRENCE_TYPES.NO_RECURRENCE) {
      handleDaysOptionChange(cadenceV);
    }
    if (cadenceV === RECURRENCE_TYPES.ANNUALLY && monthOfYearV) {
      handleMonthOfYearChange(monthOfYearV);
    }
  }, []);

  const getCadenceOptions = [
    { label: "Day", value: "day" },
    { label: "Week", value: "week" },
    { label: "Month", value: "month" },
    { label: "Year", value: "year" },
  ];

  return (
    <MDBox>
      <Grid container spacing={3} p={1}>
        <Grid item xs={12} sm={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDBox>
                <MDTypography variant="h5" fontWeight="bold">
                  Recurrence
                </MDTypography>
                <MDTypography variant="subtitle2" sx={{ color: "#7b809a" }}>
                  Report will become available
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                id="Cadence"
                disableClearable
                options={recurrenceTypes}
                onChange={(_, value) => {
                  setFieldValue("cadence.type", value.value);
                  if (daysV) {
                    setFieldValue("cadence.days", null);
                  }
                  if (monthOfYearV) {
                    setFieldValue("cadence.monthOfYear", null);
                  }
                  if (dayOfMonthV) {
                    setFieldValue("cadence.dayOfMonth", null);
                  }

                  if (value.value === RECURRENCE_TYPES.WEEKLY) {
                    handleDaysOptionChange(RECURRENCE_TYPES.WEEKLY, 7);
                  } else if (value.value === RECURRENCE_TYPES.MONTHLY) {
                    handleDaysOptionChange(RECURRENCE_TYPES.MONTHLY, 28);
                  } else if (value.value === RECURRENCE_TYPES.QUARTERLY) {
                    handleDaysOptionChange(RECURRENCE_TYPES.QUARTERLY, 10);
                  } else {
                    handleDaysOptionChange(RECURRENCE_TYPES.ANNUALLY, 12);
                  }
                }}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                value={recurrenceTypes.find((option) => option.value === cadenceV) || null}
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    variant="standard"
                    placeholder="Recurrence"
                    label="Recurrence"
                    error={touched?.cadence?.type && Boolean(errors?.cadence?.type)}
                    helperText={touched?.cadence?.type && errors?.cadence?.type}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {recurrenceTypesLoading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            {cadenceV !== RECURRENCE_TYPES.NO_RECURRENCE && cadenceV && (
              <Grid item xs={12}>
                <Autocomplete
                  fullWidth
                  id="Cadence"
                  disableClearable
                  value={
                    cadenceV && cadenceV !== RECURRENCE_TYPES.ANNUALLY
                      ? daysOptions.find((option) => option.value === daysV) || null
                      : daysOptions.find((option) => option.value === monthOfYearV) || null
                  }
                  options={daysOptions}
                  getOptionLabel={(option) => option?.label?.toString() || ""}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  onChange={(_, value) => {
                    if (cadenceV !== RECURRENCE_TYPES.ANNUALLY) {
                      setFieldValue("cadence.days", value.value);
                    } else {
                      setFieldValue("cadence.monthOfYear", value.value);
                      handleMonthOfYearChange(value.value);
                    }
                  }}
                  renderInput={(params) => (
                    <MDInput
                      {...params}
                      variant="standard"
                      placeholder={
                        cadenceV === RECURRENCE_TYPES.WEEKLY
                          ? "Day of Week"
                          : cadenceV === RECURRENCE_TYPES.MONTHLY
                          ? "Day of Month"
                          : cadenceV === RECURRENCE_TYPES.QUARTERLY
                          ? "Days before end of the Quarter"
                          : "Month Of Year"
                      }
                      label={
                        cadenceV === RECURRENCE_TYPES.WEEKLY
                          ? "Day of Week"
                          : cadenceV === RECURRENCE_TYPES.MONTHLY
                          ? "Day of Month"
                          : cadenceV === RECURRENCE_TYPES.QUARTERLY
                          ? "Days before end of the Quarter"
                          : "Month Of Year"
                      }
                      error={
                        (touched?.cadence?.days && Boolean(errors?.cadence?.days)) ||
                        (touched?.cadence?.monthOfYear && Boolean(errors?.cadence?.monthOfYear))
                      }
                      helperText={
                        (touched?.cadence?.days && errors?.cadence?.days) ||
                        (touched?.cadence?.monthOfYear && errors?.cadence?.monthOfYear)
                      }
                    />
                  )}
                />
              </Grid>
            )}
            {cadenceV === RECURRENCE_TYPES.ANNUALLY && cadenceV && (
              <Grid item xs={12}>
                <Autocomplete
                  fullWidth
                  id="Cadence"
                  disableClearable
                  value={
                    dayOfMonthV
                      ? daysOfMonth.find((option) => option.value === dayOfMonthV) || null
                      : null
                  }
                  options={daysOfMonth}
                  getOptionLabel={(option) => option?.label?.toString() || ""}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  onChange={(_, value) => {
                    setFieldValue("cadence.dayOfMonth", value.value);
                  }}
                  renderInput={(params) => (
                    <MDInput
                      {...params}
                      variant="standard"
                      placeholder="Day Of Month"
                      label="Day Of Month"
                      error={touched?.cadence?.dayOfMonth && Boolean(errors?.cadence?.dayOfMonth)}
                      helperText={touched?.cadence?.dayOfMonth && errors?.cadence?.dayOfMonth}
                    />
                  )}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDBox>
                <MDTypography variant="h5" fontWeight="bold">
                  Time to complete
                </MDTypography>
                <MDTypography variant="subtitle2" sx={{ color: "#7b809a" }}>
                  After generation, report will be due in
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xl={4} md={12} xs={12}>
                  <Autocomplete
                    fullWidth
                    id="due-date"
                    disableClearable
                    options={dueDateOptions}
                    onChange={(_, value) => {
                      setFieldValue("cadence.dueDateNum", value.value);
                    }}
                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                    getOptionLabel={(option) => option?.label?.toString() || ""}
                    value={
                      dueDateNumV
                        ? dueDateOptions.find((option) => option.value === dueDateNumV)
                        : null
                    }
                    renderInput={(params) => (
                      <MDInput
                        {...params}
                        variant="standard"
                        // placeholder={`${
                        //   dueDateOptionV
                        //     ? `${dueDateOptionV[0].toUpperCase()}${dueDateOptionV.slice(1)}`
                        //     : "Please select"
                        // }`}
                        // label={`${
                        //   dueDateOptionV
                        //     ? `${dueDateOptionV[0].toUpperCase()}${dueDateOptionV.slice(1)}`
                        //     : "Please select"
                        // }`}
                        placeholder="Value"
                        label="Value"
                        error={touched?.cadence?.dueDateNum && Boolean(errors?.cadence?.dueDateNum)}
                        helperText={touched?.cadence?.dueDateNum && errors?.cadence?.dueDateNum}
                      />
                    )}
                  />
                </Grid>
                <Grid item xl={8} md={12} xs={12}>
                  <Autocomplete
                    fullWidth
                    id="due-date"
                    disableClearable
                    options={getCadenceOptions}
                    onChange={(_, value) => {
                      setFieldValue("cadence.dueDateOption", `${value.value}`);
                    }}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    getOptionLabel={(option) => {
                      let label = option?.label;
                      if (dueDateNumV && dueDateNumV !== 1 && label) {
                        label += "s";
                        return label;
                      }
                      return label || "";
                    }}
                    value={
                      getCadenceOptions.find((option) => option.value === dueDateOptionV) || null
                    }
                    renderInput={(params) => (
                      <MDInput
                        {...params}
                        variant="standard"
                        placeholder="Time period"
                        label="Time period"
                        error={
                          touched?.cadence?.dueDateOption && Boolean(errors?.cadence?.dueDateOption)
                        }
                        helperText={
                          touched?.cadence?.dueDateOption && errors?.cadence?.dueDateOption
                        }
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Cadence;
